import React, { useState} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'


const AddNewItem = ({ AddItem }) => {

    const [item, setItem] = useState('')

    const handleSubmit = e => {
        e.preventDefault()
        if (item !== '') {
            AddItem({"item": item, "completed": false})
            setItem('')
        }
    } 

    return (
        <form onSubmit={handleSubmit}>
            <input 
                type="text" 
                placeholder="Add New Item"
                value={item}
                onChange={e => setItem(e.target.value)}
            />
            <button className="btn btn--submit"><FontAwesomeIcon icon={faPlus} alt="Add"/></button>
        </form>
    )
}

export default AddNewItem